export { default } from './Izenda.MessageNotification';


// WEBPACK FOOTER //
// ./ui/share/components/controls/MessageNotification/index.jsx